
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"51","height":"51","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('circle',{attrs:{"cx":"25.397","cy":"25.398","r":"25.357","fill":"#606060"}}),_c('path',{attrs:{"d":"M12.335 15.017a3 3 0 013-3h19.773a3 3 0 013 3v19.724a3 3 0 01-1.591 2.65l-10.018 5.326a3 3 0 01-2.842-.014l-9.755-5.307a3 3 0 01-1.567-2.635V15.017z","fill":"#fff"}}),_c('path',{attrs:{"d":"M25.211 27.115l-8.607-4.606a.244.244 0 00-.359.215v3.482c0 .09.05.172.129.215l8.837 4.729a.244.244 0 00.23 0l8.838-4.73a.244.244 0 00.128-.215v-3.481a.244.244 0 00-.359-.215l-8.607 4.606a.244.244 0 01-.23 0z","fill":"#606060"}}),_c('path',{attrs:{"d":"M25.211 34.125l-8.607-4.606a.244.244 0 00-.359.215v3.481c0 .09.05.173.129.215l8.837 4.73a.244.244 0 00.23 0l8.838-4.73a.244.244 0 00.128-.215v-3.481a.244.244 0 00-.359-.215l-8.607 4.606a.242.242 0 01-.23 0zM19.083 15.331h-1.032v4.882h1.032v-4.882zM19.747 16.182h1.494v4.031h1.02v-4.03h1.495v-.852h-4.01v.851zM24.655 20.213l.362-1.113h1.762l.362 1.113h1.106l-1.683-4.882h-1.33l-1.685 4.882h1.106zm.624-1.919l.601-1.847h.038l.601 1.847h-1.24zM28.835 20.213h1.032v-1.73h.753l.925 1.73h1.14l-1.037-1.897c.555-.239.863-.723.863-1.39 0-.97-.642-1.595-1.75-1.595h-1.926v4.882zm1.032-2.56v-1.478h.696c.596 0 .885.265.885.751 0 .484-.289.727-.88.727h-.7z","fill":"#606060"}})])
          )
        }
      }
    